<input type='search' [placeholder]='placeholder'  enterkeyhint='חיפוש' 
       role='textbox' aria-label='חיפוש שירותים באתר כל שירות. ניתן להשתמש בחיצים על מנת לנווט באפשרויות או באמצעות טאב אם משתמשים בקורא מסך.'
       #input class='focusable' [(ngModel)]='config.query' (keydown)='config.changed($event)' 
       (focus)='focus.next(true)' (blur)='focus.next(false)'
       [class.desktopStyle]='desktopStyle' [class.mobileStyle]='!desktopStyle'
       data-hj-allow
>
<button class='clear-button' *ngIf='config.searching' (click)='clear()' aria-label="ניקוי החיפוש"></button>    
